<template>
  <div class="product-container" :style="styleObject">
    <div class="product taixiu">
      <GameHeader
        :name="name"
        :game-state="gameState"
        :round="round"
        :timeout="timeout"
        :table-id="tableId"
        :data="data"
        :dealer-name="dealerName"
      />
      <GameBody
        :name="name"
        :game-state="gameState"
        :table="table"
        :round="round"
        :score="score"
        :flip-score="flipScore"
        :data="data"
        :odds="odds"
        :is-highlight-result="isHighlightResult"
        :window-focus="windowFocus"
      />
      <GameFooter
        :data="data"
        @showdetail="showdetail"
      />
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import GameHeader from '@components/common/game-header.vue';
import GameBody from '@components/taixiu/body.vue';
import GameFooter from '@components/taixiu/footer.vue';
import { GAMESTATE, GAME_TYPE, XOC_DIA } from '@config/constants.js';
import { processTick, getTimeoutGameState } from '@utils/timer.js';
import { getRound, getOdds } from '@utils/round.js';
import { convertArrToObj } from '@utils/odds.js';
import { showResult, startNewGame } from '@handlers/game-handler.js';

export default {
  components: {
    GameHeader, GameBody, GameFooter
  },
  props: {
    name: { type: String, default: "" },
    table: { type: String, default: "" },
    tableId: { type: String, default: "" },
    data: { type: Object, default: () => ({})},
    styleObject: { type: Object, default: () => ({})},
    dealerName: { type: String, default: "" },
    windowFocus: { type: Number, default: 0 },
  },
  data() {
    return {
      round: 0,
      timeout: 0,
      gameState: GAMESTATE.LOADING,
      isHighlightResult: false,
      newRound: 0,
      timeBet: 0,
      score: {},
      flipScore: {},
      odds: {},
    }
  },
  computed: {
    ...mapState('timer', ['tick']),
    ...mapState('init', ['rounds', 'roundsWithResult']),
    newResult: function() { return this.data.newResult; },
    newGame: function() { return this.data.newGame; },
  },
  watch: {
    tick: function(newVal){
      processTick(this);
    },
    newResult: function(newVal) {
      this.showingResult(newVal);
    },
    newGame: function(newVal){
      this.startingNewGame(newVal);
    },
    rounds: {
      immediate: true,
      handler(newVal) {
        if(newVal === null) return;
        const round = getRound(newVal, this.tableId);
        // console.log('rounds', newVal, round);
        this.init(round);
      },
    },
    roundsWithResult: {
      immediate: true,
      handler(newVal) {
        if(newVal === null) return;
        const round = getRound(newVal, this.tableId);
        // console.log('roundsWithResult', round);
        // this.init(round);
        if(round !== undefined){
          this.populatePreviousBets(round.userBets);
        }
      },
    },
  },
  mounted() {
    // console.log('round:', this.initRound);
    if(this.rounds === null) return;
    const odds = getOdds(this.rounds, this.tableId);
    if(odds !== null){
      this.odds = odds;
    }
  },
  methods: {
    ...mapActions('bet', ['hideBetDialogByGame']),
    ...mapActions('taixiu', [
      'clearBetValue',
      'pushNewWaitingResult',
      'setHistory',
      'getHistory',
      'setResult',
      'populateBets',
      'setMinMax',
      'calculatePercent',
    ]),
    ...mapActions('goodRoadBall', ['addGoodRoad']),
    init(round){
      if(round === undefined) {
        console.log('[taixiu] init round is undefined:', this.tableId);
        return;
      }
      // console.log('odds', round.odds)
      if(round.odds !== null && round.odds !== undefined){
        this.odds = convertArrToObj(round.odds);
      }

      const { timeout, gameState } = getTimeoutGameState(round);
      this.round = round.id;
      this.newRound = round.id;
      
      if(!isNaN(timeout)){
        this.timeout = timeout;
        this.gameState = gameState;
      }

      this.setMinMax({
        tableId: this.tableId,
        min: round.table.minAmount,
        max: round.table.maxAmount,
      });

      this.calculatePercent({
        tableId: this.tableId,
      });

      // show result
      if(round.resultRaw !== undefined){
        this.showingResult(round);
      }

      // console.log('userBets', round.userBets);
      // if(round.userBets !== undefined){
      //   this.populatePreviousBets(round.userBets);
      // }
    },
    populatePreviousBets(userBets){
      // console.log('userBets', userBets);
      const data = {
        table: this.table,
        tableId: this.tableId,
        userBets
      };
      this.populateBets(data);
    },
    showingResult(newVal) {
      showResult(this, newVal, XOC_DIA.ANIMATION_TIME, XOC_DIA.RESULT_TIME);
    },
    startingNewGame({ id, table, timeBet, odds, jackpot }) {
      this.addGoodRoad({
        tableId: this.tableId,
        data: this.data,
        gameType: GAME_TYPE.TAI_XIU
      });
      startNewGame(this, { id, table, timeBet, odds, jackpot });
    },
    showdetail(val) {
      // console.log('container - showdetail');
      this.$emit('showdetail', { ...val, name: this.name });
    }
  }
}
</script>

<style>

</style>
